export default __webpack_public_path__ + "static/media/2223 spice rack side.07944129.png";